import {
  componentNameValidationMixin,
  createStyleMixin,
  draggableMixin,
} from '@descope-ui/common/components-mixins';
import {
  forwardAttrs,
  getComponentName,
  injectStyle,
} from '@descope-ui/common/components-helpers';
import { compose } from '@descope-ui/common/utils';
import { createBaseClass } from '@descope-ui/common/base-classes';
import { ButtonClass } from '@descope-ui/descope-button/class';

export const componentName = getComponentName('outbound-app-button');

class RawOutboundAppButton extends createBaseClass({
  componentName,
  baseSelector: ':host > descope-button',
}) {
  static get observedAttributes() {
    return ['label', 'icon-src', 'icon-fill-current-color'];
  }

  constructor() {
    super();

    this.attachShadow({ mode: 'open' }).innerHTML = `
      <descope-button>
        <descope-icon class="icon"></descope-icon>
        <span class="label"></span>
      </descope-button>
    `;

    injectStyle(`
      :host {
        display: inline-block;
      }
      .hidden {
        display: none;
      }
    `, this);

    this.button = this.shadowRoot.querySelector('descope-button');
    this.icon = this.shadowRoot.querySelector('.icon');
    this.label = this.shadowRoot.querySelector('.label');
  }

  init() {
    super.init?.();

    forwardAttrs(this, this.button, {
      excludeAttrs: [
        'style',
        'class',
        'label',
        'icon-src',
        'icon-fill-current-color',
      ]
    });
  }

  updateLabel(val = '') {
    this.label.textContent = val;
    this.label.classList.toggle('hidden', !val);
  }

  updateIcon(val = '') {
    this.icon.setAttribute('src', val);
    this.icon.classList.toggle('hidden', !val);
  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    super.attributeChangedCallback?.(attrName, oldValue, newValue);

    if (oldValue !== newValue) {
      if (attrName === 'label') {
        this.updateLabel(newValue);
      } else if (attrName === 'icon-src') {
        this.updateIcon(newValue);
      }
    }
  }
}

export const OutboundAppButtonClass = compose(
  createStyleMixin({
    mappings: {
      hostWidth: {
        selector: () => ':host',
        property: 'width'
      },
      iconFillCurrentColor: {
        selector: () => 'descope-icon',
        property: ButtonClass.cssVarList.iconColor
      }
    },
  }),
  draggableMixin,
  componentNameValidationMixin,
)(RawOutboundAppButton);
